export type DefaultNeighborsLanding = 'home' | 'social';

export interface UserProfile {
    _id?: string;
    Username?: string;
    FirstName?: string;
    LastName?: string;
    Image?: string;
    defaultNeighborsLanding?: DefaultNeighborsLanding;
    [key: string]: unknown;
}

export const normalizeDefaultNeighborsLanding = (value: unknown): DefaultNeighborsLanding => {
    return value === 'social' ? 'social' : 'home';
};
